import { useEffect, useState } from 'react';

function Hero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" style={{ background: '#FAFAFA' }}>
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ec73689bd559232bf2c2ce3c6b59f49d.jpg"
          alt="Strategic AI Leadership"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/40 to-black/65"></div>
      </div>

      <div
        className={`relative max-w-5xl mx-auto px-6 lg:px-12 text-center w-full transition-all duration-1000 ease-out ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <p className="text-sm font-medium tracking-[0.3em] uppercase text-[#2DD4BF] mb-8">
          Intelligent Automation Infrastructure
        </p>

        <h1 className="text-5xl md:text-6xl lg:text-[80px] font-semibold text-white mb-8 leading-[1.05] tracking-tight">
          Intelligent Systems.
          <br />
          Strategic Advantage.
        </h1>

        <p className="text-lg md:text-xl text-white/80 mb-4 max-w-3xl mx-auto font-light leading-relaxed">
          Wazier AI designs structured automation infrastructure for service-based organizations ready to scale with precision.
        </p>

        <p className="text-base text-white/60 mb-12 max-w-2xl mx-auto leading-relaxed font-light">
          We don&apos;t sell tools. We architect intelligent systems that increase response speed, optimize workflows, and create measurable operational lift.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#contact"
            className="px-8 py-3.5 bg-white text-gray-900 text-sm font-medium rounded-full hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap"
          >
            Book a Strategy Call
          </a>
          <a
            href="#solutions"
            className="px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white text-sm font-medium rounded-full border border-white/20 hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap"
          >
            Explore Solutions
          </a>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2">
        <div className="w-6 h-10 rounded-full border-2 border-white/30 flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-white/50 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
